import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  composeMapper,
  getDesignPanelPreviewStateMap,
  getPartToPreviewStateMap,
} from '@wix/editor-elements-preview-utils';

import type {
  SubmenuDefinition,
  SubmenuCarmiProps,
  SubmenuPreviewMapperProps,
} from '../types';
import { props as viewerPropsMapper } from './Submenu.mapper';
import { hasDetachedStyleProperties } from '../../Menu/editor/DetachStyles/utils';

const props = composeMapper<
  SubmenuPreviewMapperProps,
  SubmenuDefinition,
  SubmenuCarmiProps
>()(
  viewerPropsMapper,
  {
    add: ['compPreviewState', 'styleProperties'],
  },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { compPreviewState, styleProperties = {} } = deps;
    const isComponentDetached = hasDetachedStyleProperties(styleProperties);
    const designPanelPreviewStateMap =
      getDesignPanelPreviewStateMap(compPreviewState);

    return {
      ...viewerProps,
      trackClicksAnalytics: false,
      previewWrapperProps: { isComponentDetached },
      partToPreviewStateMap: getPartToPreviewStateMap(
        designPanelPreviewStateMap,
      ),
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
